module.exports = __webpack_public_path__ + "img/footer_googleplay.39762dc5.png";